/*
 * returns a boolean indicating whether or not 'number' is between
 * 'min' and 'max'
 *
 * inBetween(0, 5, 3) -> true
 * inBetween(0, 5, 10) -> false
 */

module.exports = function inBetween(min, max, number) {
	return number > min && number < max
}
